// Форма длительности этапов цикла (день / встречи / голосование). Общая для
// панели владельца и онбординга (владелец задаёт тайминги ещё при создании
// кампании). Изолированная .gn-* разметка; сохранение через action() (он
// перезагружает setup). Все классы уже в leak-guard gn.css.

import { useState } from "react";
import { api, type CampaignTimingSettings } from "../api";

type GnAction = (label: string, run: () => Promise<unknown>) => Promise<boolean>;

const TIMING_FIELDS: { key: keyof CampaignTimingSettings; label: string }[] = [
  { key: "dayDurationMinutes", label: "День" },
  { key: "closingDurationMinutes", label: "Встречи" },
  { key: "votingDurationMinutes", label: "Голосование" },
];

export function CycleTimingCard({
  campaignId,
  value,
  action,
}: {
  campaignId: string;
  value: CampaignTimingSettings;
  action: GnAction;
}) {
  const [timing, setTiming] = useState<CampaignTimingSettings>(value);
  return (
    <div className="gn-timing">
      <span className="gn-eyebrow gn-eyebrow-p">Длительность этапов · минуты</span>
      <div className="gn-tgrid">
        {TIMING_FIELDS.map((f) => (
          <div className="gn-tf" key={f.key}>
            <small>{f.label}</small>
            <input
              className="gn-oinput"
              type="number"
              min={1}
              value={timing[f.key]}
              onChange={(e) => setTiming((t) => ({ ...t, [f.key]: Math.max(1, Number(e.target.value) || 0) }))}
            />
          </div>
        ))}
      </div>
      <button
        type="button"
        className="gn-darkbtn gn-savebtn"
        onClick={() => void action("Сохраняем тайминги…", () => api.updateCycleTimingSettings(campaignId, timing))}
      >
        Сохранить тайминги
      </button>
    </div>
  );
}
